import {observer, inject} from 'mobx-react';
import React from 'react';
import translateBase from '../../translate';
let translate = translateBase.bindComponent('bwStepBar');


@inject(stores => ({
  vBookingWizard: stores.app.vBookingWizard,
  bestOffers: stores.app.bestOffers,
  rentalTransaction: stores.app.rentalTransaction,
  offerDetailsForm: stores.app.offerDetailsForm,
  authentication: stores.app.authentication,
  vPersonalData: stores.app.vPersonalData,
  history: stores.app.history,
}))
@observer
export class BWStepBar extends React.Component {
  constructor(props) {
    super(props);
    this.lastStep = 6;
  }

  isClickable(stepNo, currentStep) {
    if(stepNo === currentStep) {
      return false;
    }
    let {vBookingWizard} = this.props;
    switch(stepNo) {
      case 1:
        return !vBookingWizard.wasStepVisited(7);
        break;
      case 2:
        return /*this.isClickable(1, currentStep)*/ true &&
          vBookingWizard.wasStepVisited(2) &&
          !vBookingWizard.wasStepVisited(7) &&
          this.props.rentalTransaction.mainObjectOffers.length > 0; //&& 
          //!(this.props.offerDetailsForm.canApplyNewValues);
        break;
      case 3:
        return /*this.isClickable(2, currentStep)*/ true &&
        !vBookingWizard.wasStepVisited(7) &&
        vBookingWizard.wasStepVisited(3);
        break;
      case 4:
        return /*this.isClickable(3, currentStep)*/ true &&
        !vBookingWizard.wasStepVisited(7) &&
        vBookingWizard.wasStepVisited(4); 
        break;
      case 5:
        return /*this.isClickable(4, currentStep)*/ true && 
          vBookingWizard.wasStepVisited(5) &&
          !vBookingWizard.wasStepVisited(7) &&
          (this.props.authentication.loggedIn || this.props.vPersonalData.hasBeenSubmitted);
        break; 
      case 6:
        return false;
        break;
    }
  }

  getStepClass(forStep, activeStep) {
    if(forStep === activeStep) {
        return "active step" + (this.isClickable(forStep, activeStep) ? " clickable" : "");
    }
    if(forStep > activeStep) {
        return "step" + (this.isClickable(forStep, activeStep) ? " clickable" : "");
    }
    if(forStep < activeStep) {
        return "done step" + (this.isClickable(forStep, activeStep) ? " clickable" : "");
    }
  }

  getStepIcon(forStep, dispNumber, activeStep) {
      if(forStep < activeStep) {
          return <div className="icon"><i className="fa fa-check" aria-hidden="true"></i></div>
      } else {
          return <div className="icon"><span>{dispNumber}</span></div>
      }
  }

  getStepProps(stepNo, activeStep) {
    return {
      onClick: this.isClickable(stepNo, activeStep) && (() => this.props.history.push(`/bookingWizard/${stepNo}`)),
    }
  }

  render() {    
    const {activeStep, vBookingWizard, showAllSteps} = this.props;
    const servicesPassed = window.sessionStorage.getItem('servicesPassed');
    const accessoriesPassed = window.sessionStorage.getItem('accessoriesPassed');
    let dispNumber = 1;
    //console.log('Any services to book:', vBookingWizard.anyServicesToBook)
    //console.log('Any accessories to book:', vBookingWizard.anyAccessoriesToBook)
    return (
        <section className="wizardsteps-wrapper booking-view">
            <div className="wrapper wizardsteps-container steps">
                <div className={this.getStepClass(1, activeStep)} {...this.getStepProps(1, activeStep)}>
                    {this.getStepIcon(1, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("bookingDates", "Buchungsdaten")}</div>
                    </div>
                </div>
                {(vBookingWizard.anyServicesToBook || (showAllSteps && servicesPassed)) && <div className={this.getStepClass(2, activeStep)} {...this.getStepProps(2, activeStep)}>
                    {this.getStepIcon(2, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("services", "Dienstleistungen")}</div>
                    </div>
                </div>}
                {(vBookingWizard.anyAccessoriesToBook || (showAllSteps && accessoriesPassed)) && <div className={this.getStepClass(3, activeStep)} {...this.getStepProps(3, activeStep)}>
                    {this.getStepIcon(3, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("accessories", "Zubehör")}</div>
                    </div>
                </div>}
                <div className={this.getStepClass(4, activeStep)} {...this.getStepProps(4, activeStep)}>
                    {this.getStepIcon(4, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("personalData", "Personalien")}</div>
                    </div>
                </div>
                <div className={this.getStepClass(5, activeStep)} {...this.getStepProps(5, activeStep)}>
                    {this.getStepIcon(5, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("review", "Überprüfen")}</div>
                    </div>
                </div>                
                <div className={this.getStepClass(6, activeStep)} {...this.getStepProps(6, activeStep)}>
                    {this.getStepIcon(6, dispNumber++, activeStep)}
                    <div className="content">
                        <div className="title">{translate("payment", "Zahlung")}</div>
                    </div>
                </div>
            </div>
            <div className="step-bar" style={{width: `${activeStep/this.lastStep*100}%`}}></div>
        </section>      
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/BWStepBar.js